<div class="bg-white">
  <div class="border-bottom p-4">
    <h3 class="pt-2">
      <span *ngIf="isUpdate">{{ 'Sellers.Products.Edit' | translate }} </span>
      {{ 'Sellers.Products.RequestActivation' | translate }}
    </h3>
  </div>
  <div class="p-4">
    <div class="alert alert-success" role="alert" *ngIf="isAdmin">
      {{ 'Sellers.Products.ChangeBusinessInfo' | translate }}
    </div>
    <!-- start page 1 -->
    <div class="page-1 w-100" *ngIf="currentPage == 1">
      <form *ngIf="page1Form" class="row" [formGroup]="page1Form" enctype="multipart/form-data;charset=UTF-8">

        <div class="col-6 mb-3">
          <div class="form-group">
            <label>{{ 'Sellers.Products.BusinessName' | translate }}</label>
            <input [formControl]="convertPage1Controls('businessName')"
                   type="text" class="form-control" readonly>
          </div>
        </div>

        <div class="col-6 mb-3">
          <div class="form-group">
            <label>{{ 'Sellers.Products.ContactFullName' | translate }}</label>
            <input [formControl]="convertPage1Controls('CPFullName')"
                   type="text" class="form-control" readonly>
          </div>
        </div>

        <div class="col-6 mb-3">
          <div class="form-group">
            <label>{{ 'Sellers.Products.Email' | translate }}</label>
            <input [formControl]="convertPage1Controls('email')"
                   type="text" class="form-control" readonly>
            <span>
              <span title="Verified" *ngIf="mail_verified">&#10004;</span>
              <span title="Un-verified" *ngIf="!mail_verified">&#10008;</span>
            </span>
          </div>
        </div>

        <div class="col-6 mb-3">
          <div class="form-group">
            <label>{{ 'Sellers.Products.PhoneNumber' | translate }}</label>
            <input [formControl]="convertPage1Controls('phoneNumber')"
                   type="text" class="form-control" readonly>
            <span>
              <span title="Verified" *ngIf="phone_verified">&#10004;</span>
              <span title="Un-verified" *ngIf="!phone_verified">&#10008;</span>
            </span>
          </div>
        </div>

        <div class="col-12 mb-3">
          <div class="form-group">
            <label>{{ 'Sellers.Products.BusinessDescription' | translate }}</label>
            <textarea [formControl]="convertPage1Controls('description')"
                      class="form-control disabled" readonly></textarea>
            <small class="text-danger" *ngIf="fvPage1.formErrors.description">
              {{ fvPage1.formErrors.description }}
            </small>
          </div>
        </div>

        <div class="col-6 mb-3">
          <div class="form-group">
            <label>{{ 'Sellers.Products.Website' | translate }}</label>
            <input [disabled]="ViewRequestFlag"
                   [formControl]="convertPage1Controls('website')"
                   type="text" class="form-control">
            <small class="text-danger" *ngIf="fvPage1.formErrors.website">
              {{ fvPage1.formErrors.website }}
            </small>
          </div>
        </div>

        <div class="col-3 mb-3">
          <div class="form-group">
            <label>{{ 'Sellers.Products.FacebookPage' | translate }}</label>
            <input readonly [formControl]="convertPage1Controls('facebook')"
                   type="text" class="form-control">
            <span>
              <span title="Verified" *ngIf="facebook_verified">&#10004;</span>
              <span title="Un-verified" *ngIf="!facebook_verified">&#10008;</span>
            </span>
            <small class="text-danger" *ngIf="fvPage1.formErrors.facebook">
              {{ fvPage1.formErrors.facebook }}
            </small>
          </div>
        </div>
        <div class="col-3 mb-3" *ngIf="!isAdmin">
          <div class="form-group">
            <label>{{ 'Sellers.Products.FacebookVerficationCode' | translate }}</label>
            <div class="input-group mb-3">
              <input readonly type="text" class="form-control"
                     [formControl]="convertPage1Controls('facebook_verfication')">
              <div class="input-group-append">
                <button class="btn btn-white p-2 pb-0"
                        (click)="copyToClipboard(convertPage1Controls('facebook_verfication').value)"
                        aria-label="Copy to clipboard">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="col-6 mb-3">
          <div class="form-group">
            <label>{{ 'Sellers.Products.InstagramAccount' | translate }}</label>
            <input [disabled]="ViewRequestFlag"
                   [formControl]="convertPage1Controls('instagram')"
                   type="text" class="form-control">
            <small class="text-danger" *ngIf="fvPage1.formErrors.instagram">
              {{ fvPage1.formErrors.instagram }}
            </small>
          </div>
        </div>

        <div class="col-6 mb-3">
          <div class="form-group">
            <label>{{ 'Sellers.Products.RegisteredBusiness' | translate }}</label>
            <div class="d-block w-100 mt-1">
              <mat-radio-group [formControl]="convertPage1Controls('hasRegisteredBusiness')"
                               aria-label="{{ 'Sellers.Products.SelectOption' | translate }}"
                               [disabled]="ViewRequestFlag">
                <mat-radio-button [value]="true" class="me-3">
                  {{ 'Sellers.Products.Yes' | translate }}
                </mat-radio-button>
                <mat-radio-button [value]="false">
                  {{ 'Sellers.Products.No' | translate }}
                </mat-radio-button>
              </mat-radio-group>
            </div>
            <small class="text-danger" *ngIf="fvPage1.formErrors.hasRegisteredBusiness">
              {{ fvPage1.formErrors.hasRegisteredBusiness }}
            </small>
          </div>
        </div>
      </form>
    </div>
    <!-- start page 2-->
    <div class="page-2 w-100" *ngIf="currentPage == 2">
      <form class="row" [formGroup]="page2Form" enctype="multipart/form-data;charset=UTF-8">
        <div class="col-6 mb-3">
          <div *ngIf="!ViewRequestFlag && !isUpdate" class="form-group">
            <label>{{ 'Sellers.Products.UploadCommercialRegister' | translate }}</label>
            <input type="file" (change)="fileChange('commercialRegister', $event)"
                   [formControl]="convertPage2Controls('commercialRegister')"
                   class="form-control-file form-control">
            <small class="text-danger" *ngIf="fvPage2.formErrors.commercialRegister">
              {{ fvPage2.formErrors.commercialRegister }}
            </small>
          </div>
          <div *ngIf="isUpdate" class="form-group">
            <label>{{ 'Sellers.Products.CommercialRegister' | translate }}: {{commercialImage}}</label>
              <input  [formControl]="page2Form.controls['commercialRegister']"
              (change)="fileChange('commercialRegister', $event,'commercialImg')" type="file"
               class="form-control-file hiddenInput" id="commercialImg"
               accept="image/*" style="display:none">
            <small class="form-error"
                   *ngIf="fvPage2.formErrors.commercialRegister">
              {{ fvPage2.formErrors.commercialRegister }}
            </small>
            <button type="button" (click)="uploadImage('commercialImg')"
                    class="btn btn-primary">
              {{ 'Sellers.Products.Upload' | translate }}
            </button>
          </div>

          <div *ngIf="ViewRequestFlag" class="form-group">
            <app-document-display [document]="ViewRequestData.commercialRegister" ></app-document-display>
            <label>{{ 'Sellers.Products.DownloadCommercialRegister' | translate }} </label>
            <a (click)="download(ViewRequestData.commercialRegister , 'commercialRegister')"
               class="btn btn-lg text-primary">
              {{ 'Sellers.Products.Download' | translate }}
            </a>
          </div>
        </div>
        <div class="col-6 mb-3">
          <div *ngIf="!ViewRequestFlag && !isUpdate" class="form-group">
            <label>{{ 'Sellers.Products.UploadTaxCard' | translate }}</label>
            <input [formControl]="convertPage2Controls('taxCard')"
                   (change)="fileChange('taxCard', $event)" type="file"
                   class="form-control-file form-control">
            <small class="text-danger" *ngIf="fvPage2.formErrors.taxCard">
              {{ fvPage2.formErrors.taxCard }}
            </small>
          </div>

          <div *ngIf="isUpdate" class="form-group">
            <label>{{ 'Sellers.Products.TaxCard' | translate }} : {{taxCardImage}}</label>
             <input [formControl]="page2Form.controls['taxCard']"
                    (change)="fileChange('taxCard', $event,'taxCardImg')" type="file"
                    class="form-control-file hiddenInput" id="taxCardImg"
                    accept="image/*" style="display:none">
            <small class="form-error" *ngIf="fvPage2.formErrors.taxCard">
              {{ fvPage2.formErrors.taxCard }}
            </small>
            <button type="button" (click)="uploadImage('taxCardImg')"
                    class="btn btn-primary">
              {{ 'Sellers.Products.Upload' | translate }}
            </button>
          </div>

          <div *ngIf="ViewRequestFlag" class="form-group">
            <app-document-display [document]="ViewRequestData.taxCard" >
            </app-document-display>
            <label>{{ 'Sellers.Products.DownloadTaxCard' | translate }} </label>
            <a (click)="download(ViewRequestData.taxCard , 'taxCard')"
               class="btn btn-lg text-primary">
              {{ 'Sellers.Products.Download' | translate }}
            </a>
          </div>
        </div>
      </form>
    </div>
    <!-- start page 3-->
    <div class="page-3 w-100" *ngIf="currentPage == 3">
      <form class="row" [formGroup]="page3Form" enctype="multipart/form-data;charset=UTF-8">
        <div class="col-12 mb-3">
          <div class="form-group">
            <label>{{ 'Sellers.Products.DescribeProducts' | translate }}</label>
            <textarea [disabled]="ViewRequestFlag"
                      [formControl]="convertPage3Controls('productsDescription')"
                      class="form-control"></textarea>
            <small class="text-danger"
                   *ngIf="fvPage3.formErrors.productsDescription">
              {{ fvPage3.formErrors.productsDescription }}
            </small>
          </div>
        </div>
        <div class="col-6 mb-3">
          <div class="form-group">
            <label>{{ 'Sellers.Products.AveragePriceProduct' | translate }}</label>
            <input [disabled]="ViewRequestFlag"
                   [formControl]="convertPage3Controls('averagePrice')"
                   type="text" class="form-control">
            <small class="text-danger" *ngIf="fvPage3.formErrors.averagePrice">
              {{ fvPage3.formErrors.averagePrice }}
            </small>
          </div>
        </div>
        <div class="col-6 mb-3">
          <div class="form-group">
            <label>{{ 'Sellers.Products.CustomersNationality' | translate }}</label>
            <input [disabled]="ViewRequestFlag" class="form-control"
                   [formControl]="convertPage3Controls('customersFromEgypt')">
            <small class="text-danger"
                   *ngIf="fvPage3.formErrors.customersFromEgypt">
              {{ fvPage3.formErrors.customersFromEgypt }}
            </small>
          </div>
        </div>
        <div class="col-6 mb-3">
          <!-- Upload -->
          <div *ngIf="!ViewRequestFlag && !isUpdate" class="form-group">
            <label>{{ 'Sellers.Products.UploadIDFront' | translate }}</label>
            <input [formControl]="convertPage3Controls('personalIdFront')"
                   (change)="fileChange('personalIdFront', $event)"
                   type="file" class="form-control-file">
            <small class="text-danger" *ngIf="fvPage3.formErrors.personalIdFront">
              {{ fvPage3.formErrors.personalIdFront }}
            </small>
          </div>
          <!-- View -->
          <div *ngIf="isUpdate" class="form-group">
            <label>{{ 'Sellers.Products.PersonalIDFront' | translate }}: {{frontImage}}</label>
            <input [formControl]="page3Form.controls['personalIdFront']"
                   (change)="fileChange('personalIdFront', $event,'frontImg')" type="file"
                   class="form-control-file hiddenInput" id="frontImg"
                   accept="image/*" style="display:none">
            <small class="form-error" *ngIf="fvPage3.formErrors.personalIdFront">
              {{ fvPage3.formErrors.personalIdFront }}
            </small>
            <button type="button" (click)="uploadImage('frontImg')" class="btn btn-primary">
              {{ 'Sellers.Products.Upload' | translate }}
            </button>
          </div>
          <!-- Download -->
          <div *ngIf="ViewRequestFlag && !isUpdate" class="form-group">
            <app-document-display [document]="ViewRequestData.personalIdFront" ></app-document-display>
            <label>{{ 'Sellers.Products.DownloadIDFront' | translate }} </label>
            <a (click)="download(ViewRequestData.personalIdFront , 'personalIdFront')"
               class="btn btn-lg text-primary">
              {{ 'Sellers.Products.Download' | translate }}
            </a>
          </div>
        </div>
        <div class="col-6 mb-3">
          <!-- Upload -->
          <div *ngIf="!ViewRequestFlag && !isUpdate" class="form-group">
            <label>{{ 'Sellers.Products.UploadIDBack' | translate }}</label>
            <input [formControl]="convertPage3Controls('personalIdBack')" (change)="fileChange('personalIdBack', $event)"
                   type="file" class="form-control-file">
            <small class="text-danger"
                   *ngIf="fvPage3.formErrors.personalIdBack">
              {{ fvPage3.formErrors.personalIdBack }}
            </small>
          </div>
          <!-- View -->
          <div *ngIf="isUpdate" class="form-group">
            <label>{{ 'Sellers.Products.PersonalIDBack' | translate }}: {{backImage}}</label>
            <input [formControl]="page3Form.controls['personalIdBack']"
                   (change)="fileChange('personalIdBack', $event,'backImg')"
                   type="file" class="form-control-file hiddenInput d-none" id="backImg"
                   accept="image/*">
            <small class="form-error"
                   *ngIf="fvPage3.formErrors.personalIdBack">
              {{ fvPage3.formErrors.personalIdBack }}
            </small>
            <button type="button" (click)="uploadImage('backImg')"
                    class="btn btn-primary">
              {{ 'Sellers.Products.Upload' | translate }}
            </button>

          </div>
          <!-- Download -->
          <div *ngIf="ViewRequestFlag && !isUpdate" class="form-group">
            <app-document-display [document]="ViewRequestData.personalIdBack" ></app-document-display>
            <label>{{ 'Sellers.Products.DownloadIDBack' | translate }} </label>
            <a (click)="download(ViewRequestData.personalIdBack , 'personalIdBack')"
               class="btn btn-lg text-primary">
              {{ 'Sellers.Products.Download' | translate }}
            </a>
          </div>
        </div>
        <div class="col-6 mb-3">
          <div>
            <span>{{ 'Sellers.Products.ContactLogistics' | translate }}: <strong style="color: #121270;">CustomerSupportPhone</strong></span>
          </div>
        </div>
      </form>
    </div>
    <!-- Error -->
    <div *ngIf="saveError" class="p-2 text-danger ms-2">
      <p>{{ saveError }}</p>
    </div>
  </div>

  <div class="border-top p-4">
    <div class="d-flex justify-content-between">
      <div class="col-auto" *ngIf="currentPage !== 1">
        <button (click)="currentPage = 1" class="btn btn-outline-primary me-2">
          {{ 'Sellers.Products.PreviousStep' | translate }}
        </button>
      </div>
      <div class="ms-auto col-auto">
        <button *ngIf="ViewRequestFlag && currentPage !== 1" [disabled]="!RequestIsPending"
                (click)="reject()" class="btn btn-outline-danger">
          {{ 'Sellers.Products.Reject' | translate }}
        </button>
        <button *ngIf="ViewRequestFlag && currentPage !== 1" [disabled]="!RequestIsPending"
                (click)="accept()" class="btn btn-primary">
          {{ 'Sellers.Products.Accept' | translate }}
        </button>
        <button *ngIf="!ViewRequestFlag || (ViewRequestFlag&&currentPage==1)"
                (click)="nextOrSubmit()" class="btn btn-primary">
          {{currentPage ==1 ? ('Sellers.Products.NextStep' | translate) : ('Sellers.Products.Submit' | translate)}}
        </button>
      </div>
    </div>
    <div *ngIf="ViewRequestFlag" class="col-auto d-flex justify-content-between mt-2">
      <button (click)="nextOrPrevious('prev')" class="btn btn-primary mb-2 col-md-2">
        < {{ 'Sellers.Products.PreviousContract' | translate }}
      </button>
      <button (click)="nextOrPrevious('next')" class="btn btn-primary mb-2 col-md-2 float-end">
        {{ 'Sellers.Products.NextContract' | translate }} >
      </button>
    </div>
  </div>
</div>
